import homenowGreenLogo from '../../img/homenow-green.png'
import roofnowTrimmedLogo from '../../img/roofnow-trimmed.png'

/**
 * Logo files of the cover-only brands (`COVER_ONLY_COMPANIES`, common/), by
 * short name. Imported as files, never base64 (B165).
 *
 * HOMENOW uses the green logo, same as the app icon and login (Luis Oct 30).
 * ROOFNOW uses the same trimmed logo as the contract (reportContractLogo): the
 * "ROOFNOW PLACEHOLDER" box showed up on the cover selector (Jaron, Nov 4).
 */
export const COVER_ONLY_LOGOS: Readonly<Record<string, string>> = {
  HOMENOW: homenowGreenLogo,
  ROOFNOW: roofnowTrimmedLogo,
}
